import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  constructor(
    private messageService: NzMessageService,
    private notificationService: NzNotificationService
  ) {}

  /** 服务端错误 */
  displayError(error: HttpErrorResponse) {
    // this.notificationService.html(
    //   `<strong>请求网络时发生了一些错误</strong> <br>
    //    <span style="color: red">错误代码 :</span> <strong>${error.status}<strong> <br>
    //    <span>错误信息 :</span> <strong>${error.statusText}<strong>
    //   `
    // );
    const _nowTime = +new Date();
    if (_nowTime - window['lastTime'] > 4000 || !window['lastTime']) {
      this.messageService.create('error', `网络请求错误 ${error.statusText}`);
      window['lastTime'] = _nowTime;
    }
  }

  /** 本地错误 */
  displayLocalError(error: { error_code: number; error_msg: string }) {
    this.messageService.create('warning', `${error.error_msg}`, {
      nzDuration: 4000
    });
    // this.notificationService.html(
    //   `<strong>提交数据时发生了一些错误</strong> <br>
    //    <span>错误代码 :</span> <strong>${error.error_code}<strong> <br>
    //    <span>错误信息 :</span> <strong>${error.error_msg}<strong>
    //   `
    // );
  }
  /** 自定义错误 */
  displayCustomError(params: any) {
    return this.notificationService.create(
      params.type,
      params.title,
      params.content,
      params.options
    );
  }

  removeError(id) {
    this.notificationService.remove(id);
  }
}
